import { Pet } from "../../core/pet";
import { Resistance, type AbnormalResistance } from "../../core/pet";
import { AbilityValue } from "../../core/abval";
import * as type from "../../core/type";
import * as skill from "../skill/阿克希亚";
import { Soulmark } from "../../core/soulmark";
import { Skin } from "../../core/skin";

export class 阿克希亚 extends Pet {
    /**
     *
     * @param ablis 能力值
     * @param resis 伤害抗性
     * @param abnormalResistance 异常抗性，默认无
     */
    constructor(ablis: AbilityValue, resis: Resistance, abnormalResistance: ReadonlyArray<Readonly<AbnormalResistance>> = []) {
        super(50, "阿克希亚", type.冰, ablis);
        this.抗性 = resis;
        this.异常抗性 = abnormalResistance;
        this.魂印 = new Soulmark([
            "1. 塞西莉亚星的神兽阿克希亚受到寒冰的守护，每回合开始时为自身附加200点护盾和200点护罩（不可叠加），并且不受能力下降影响。",
            "2. 自身使用攻击技能时，无视对手的防御、特防能力提升效果，并且使对手下1回合先制-2；若对手不处于异常状态，则附加对手最大体力1/3的固定伤害。",
            "3. 自身使用属性技能时，令对手防御、特防等级-1，且有50%的几率弱化效果翻倍，未触发则免疫下1次异常状态；若对手不处于能力下降状态，则吸取对手最大体力的1/3。",
        ]);
        this.技能组 = [
            skill.千雪折樱,
            skill.圣灵闪,
            skill.冰封王座,
            skill.极冰风暴,
            skill.极度冰点,
        ];
        this.皮肤组.push(new Skin(48, "索拉"));
        this.皮肤组.push(new Skin(49, "赫拉丝"));
    }
}
